"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CheckMarkIcon = _interopRequireDefault(require("../Icons/CheckMarkIcon"));

var _TextLabel = _interopRequireDefault(require("../Typography/TextLabel"));

var _Loader = _interopRequireDefault(require("../Loader/Loader"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _StackingLayout = _interopRequireDefault(require("../Layouts/StackingLayout"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * SelectDropdown is a private component being used in Select component.
 */
var SelectDropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectDropdown, _React$Component);

  function SelectDropdown() {
    _classCallCheck(this, SelectDropdown);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectDropdown).apply(this, arguments));
  }

  _createClass(SelectDropdown, [{
    key: "renderRowsData",
    value: function renderRowsData() {
      var _this$props = this.props,
          selectedRow = _this$props.selectedRow,
          rowsData = _this$props.rowsData,
          rowKeyAttribute = _this$props.rowKeyAttribute,
          onSelectedChange = _this$props.onSelectedChange,
          noDataMessage = _this$props.noDataMessage,
          _this$props$rowRender = _this$props.rowRenderer,
          rowRenderer = _this$props$rowRender === void 0 ? function () {
        return 0;
      } : _this$props$rowRender;

      if (!rowsData.length) {
        return _react.default.createElement(_TextLabel.default, {
          className: "nothing-message"
        }, noDataMessage);
      }

      var rowNodes = [];
      rowsData.forEach(function (row, index) {
        var label = row.label,
            disabled = row.disabled,
            rowProps = row.rowProps;
        var key = row[rowKeyAttribute] || index;

        var checkMarkNode = _react.default.createElement("div", {
          className: "check-mark-wrapper"
        });

        var isSelected = selectedRow && selectedRow[rowKeyAttribute] === key;

        if (isSelected) {
          checkMarkNode = _react.default.createElement("div", {
            className: "check-mark-wrapper"
          }, _react.default.createElement(_CheckMarkIcon.default, null));
        }

        var rowNode = rowRenderer(row, isSelected) || label;
        var eventListeners = {};

        if (!disabled) {
          eventListeners.onMouseDown = function () {
            return onSelectedChange(row);
          };
        }

        rowNodes.push(_react.default.createElement(_FlexLayout.default, _extends({
          key: key,
          className: "select-row",
          itemSpacing: "10px",
          alignItems: "center",
          padding: "10px",
          "data-disabled": !!disabled
        }, rowProps, eventListeners), checkMarkNode, _react.default.createElement("div", {
          className: "label-wrapper"
        }, rowNode)));
      });
      return rowNodes;
    }
  }, {
    key: "renderLoadingData",
    value: function renderLoadingData() {
      var loadingMessage = this.props.loadingMessage;
      return _react.default.createElement(_FlexLayout.default, {
        padding: "10px",
        justifyContent: "space-between",
        alignItems: "center"
      }, _react.default.createElement(_TextLabel.default, null, loadingMessage), _react.default.createElement(_Loader.default, null));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          loading = _this$props2.loading,
          rowsData = _this$props2.rowsData,
          rowKeyAttribute = _this$props2.rowKeyAttribute,
          selectedRow = _this$props2.selectedRow,
          loadingMessage = _this$props2.loadingMessage,
          noDataMessage = _this$props2.noDataMessage,
          onSelectedChange = _this$props2.onSelectedChange,
          rowRenderer = _this$props2.rowRenderer,
          type = _this$props2.type,
          props = _objectWithoutProperties(_this$props2, ["className", "loading", "rowsData", "rowKeyAttribute", "selectedRow", "loadingMessage", "noDataMessage", "onSelectedChange", "rowRenderer", "type"]);

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement(_StackingLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(clsPrfx, " ").concat(clsPrfx, "-select-dropdown")),
        "data-type": type,
        itemSpacing: "0px"
      }, props), loading ? this.renderLoadingData() : this.renderRowsData());
    }
  }]);

  return SelectDropdown;
}(_react.default.Component);

exports.default = SelectDropdown;
SelectDropdown.defaultProps = {
  rowKeyAttribute: 'key',
  rowsData: [],
  loading: false,
  noDataMessage: _I18nManager.default.t('Select', 'no_data_message'),
  loadingMessage: _I18nManager.default.t('Select', 'loading_message'),
  onSelectedChange: function onSelectedChange() {
    return 0;
  },
  type: 'default'
};
SelectDropdown.propTypes = {
  className: _propTypes.default.string,

  /**
   * Array of rows.  Each row is a select option.
   */
  rowsData: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Unique string/num identifier for this item.
     * Unless props.rowKeyAttribute defined a different string, 'key' is required.
     */
    key: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

    /**
     * When this item is selected this is the label used to display on
     * the top level selected items input.
     * This is also used to display in the drop down option.  If you need
     * to customize what to display for each row see pros.rowRenderer
     */
    label: _propTypes.default.string.isRequired
  })),

  /**
   * By default the drop down options render each row with row.label.<br>
   * This callback allows you to customize your rendering of row data.<br>
   * rowRenderer(rowData, isSelected)<br>
   * @param {object} rowData: This is the data for the row to be rendered.<br>
   * @param {boolean} isSelected: true if it is marked as selected, false otherwise.<br>
   * @return {ReactNode} - The function should return a React node.<br>
   */
  rowRenderer: _propTypes.default.func,

  /**
   * The key attribute in a row item from rowsData[] to use as
   * a unique identifier.
   */
  rowKeyAttribute: _propTypes.default.string,

  /**
   * Callback function to handle the when a row is selected.
   * onSelectedChange(selectedRow)<br>
   * @param {object} selectedRow: one of the row in rowsData.
   */
  onSelectedChange: _propTypes.default.func,

  /**
   * Message to display when rowsData is empty.
   */
  noDataMessage: _propTypes.default.string,

  /**
   * To indicate that rowsData is being loaded.
   */
  loading: _propTypes.default.bool,

  /**
   * Customize the display string for when loading is set to true.
   */
  loadingMessage: _propTypes.default.string,

  /**
   * Type of select drop down.
   */
  type: _propTypes.default.oneOf(['default', 'mini'])
};